import { actionList, badgeDinamicState, nameLink, statusActiveOptions } from "../commons/commonFunctions"

export const UserList = [
    {
        name: 'Nombre',
        selector: 'fullName',
        sortable: true,
        searchable: true,
        width: '22%',
        cell: row => nameLink(row, 'user', 'user', 'fullName')
    },
    {
        name: 'Login',
        selector: 'login',
        sortable: true,
        searchable: true,
        width: '22%'
    },
    {
        name: 'Rol',
        selector: 'role',
        sortable: true,
        searchable: false,
        width: '23%',
        cell: (row) => row.role?.name
    },
    {
        name: 'Estado',
        selector: 'status',
        sortable: true,
        searchable: true,
        select: 'Status',
        width: '10%',
        cell: row => badgeDinamicState(row, 'user', statusActiveOptions)
    }
]